import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function PageHeader({ title, breadcrumb }) {
  const location = useLocation();

  return (
    <div className="pro-page-header">
      {/* Background layers */}
      <div className="page-header-bg"></div>
      <div className="page-header-overlay"></div>
      <div className="page-header-dots"></div>

      <div className="container position-relative">
        <div className="page-header-content">
          <div className="page-header-badge">
            <i className="fa fa-home me-2"></i>
            <Link to="/">Home</Link>
            <i className="fa fa-chevron-right mx-2" style={{ fontSize: 10 }}></i>
            <span>{breadcrumb}</span>
          </div>
          <h1 className="page-header-title">{title}</h1>
          <div className="page-header-line">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
  );
}
